import type { ReactNode } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { CONTENT_HEIGHT_SX } from '../../../pages/layout/chrome';

interface PageFrameProps {
    children: ReactNode;
    fill?: boolean;
    sx?: SxProps<Theme>;
}

export function PageFrame({ children, fill = false, sx = [] }: PageFrameProps) {
    return (
        <Box
            sx={[
                {
                    px: { xs: 1.5, md: 3 },
                    py: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                },
                fill
                    ? {
                          ...CONTENT_HEIGHT_SX,
                          boxSizing: 'border-box',
                          overflow: 'hidden',
                      }
                    : {
                          height: '100%',
                          overflowY: 'auto',
                          '& > *': { flexShrink: 0 },
                      },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Box>
    );
}
